module.exports = __webpack_public_path__ + "static/media/relatedLinkCell.bb975240.svg";